import { gql } from '@apollo/client';

import { Quote } from '../../types/quote';
import { EventRequest } from '../../types/eventRequest';
import { Event } from '../../types/event';

type EventFields = Pick<
  Event,
  | 'uuid'
  | 'id'
  | 'date'
  | 'type'
  | 'location_line_1'
  | 'location_city'
  | 'custom_event_name'
  | 'state'
>;

type EventRequestFields = Pick<EventRequest, 'category_tier2'>;

type QuoteFields = Pick<Quote, 'uuid' | 'published'>;

export type CustomerEvent = EventFields & {
  event_requests: Array<
    EventRequestFields & {
      quotes: Array<QuoteFields>;
    } & {
      quote_limited?: boolean;
    }
  >;
};

export interface CustomerEvents {
  events: Array<CustomerEvent>;
}

export const CUSTOMER_EVENTS = gql`
  query customerEvents($filter: CustomerEventsFilter) {
    events: customerEvents(filter: $filter) {
      uuid
      id
      date
      start_time
      end_time
      state
      type
      description
      lead_time
      postcode
      location_line_1
      location_line_2
      location_city
      urgency
      source
      partnership
      partnership_id
      postcode_prefix
      supplier_referral
      user_id
      freshsales_id
      freshsales_stage
      unread_quotes_email_sent
      location_notes
      upcoming_event_reminder_sent
      approximate_location
      coordinates
      high_demand
      custom_event_name
      created
      updated
      attribution_data_id
      event_requests {
        category_tier2
        quotes {
          uuid
          published
        }
        quote_limited
      }
    }
  }
`;
